import React, { useRef } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import LinkMUI from '@material-ui/core/Link'
import { makeStyles, useTheme } from '@material-ui/core'
import upperCase from 'lodash/upperCase'

import { colors } from 'theme'

import TextLink from 'ui/TextLink'
import useLogEvent from 'amplitude/useLogEvent'

import { formatHref } from 'utils/url'
import { MODAL_OPENED_EVENT } from 'amplitude/events'
import useLogSuggestTitle from 'bookSuggestions/useLogSuggestTitle'
import { logModalOpened, toggleDialog } from 'utils/dialog/utils'
import Dialog from 'bookSuggestions/Dialog'
import useLogEventToAll from 'utils/useLogEventToAll'

const Link = ({ external, path, slug, id, children, ...props }) => {
  const theme = useTheme()

  const getTo = () => {
    if (id === 'suggest-book-title') return undefined

    return `/${slug}`
  }

  if (path || external) {
    return (
      <LinkMUI
        variant="body2"
        target={path ? '_blank' : null}
        rel="noopener"
        href={external ? `/${slug}` : formatHref(path)}
        style={{ textDecoration: 'none', marginTop: theme.spacing(2) }}
        {...props}
      >
        {children}
      </LinkMUI>
    )
  }

  return (
    <TextLink to={getTo()} variant="body2" {...props}>
      {children}
    </TextLink>
  )
}

export default ({ title, page, oldVersion }) => {
  const classes = useStyles({ oldVersion })
  const logEvent = useLogEvent()
  const log = useLogEventToAll()

  const dialogRef = useRef(null)
  const onToggle = toggleDialog(
    dialogRef,
    logModalOpened(log, MODAL_OPENED_EVENT, dialogRef),
  )
  const logSuggestTitle = useLogSuggestTitle({ action: MODAL_OPENED_EVENT })

  const handleToggleSuggestTitle = () => {
    logSuggestTitle('Footer')
    onToggle()
  }

  return (
    <Grid
      item
      sm={oldVersion && 'auto'}
      xs={oldVersion ? 6 : 12}
      md={!oldVersion && 'auto'}
      className={classes.grid}
    >
      <Typography variant="body2" className={classes.title}>
        {upperCase(title)}
      </Typography>
      {page.map(
        ({
          Icon,
          id,
          slug,
          name,
          path,
          eventName,
          onClick,
          eventProps,
          external,
        }) => (
          <Link
            key={id}
            path={path}
            id={id}
            slug={slug}
            variant="body2"
            component={oldVersion ? undefined : 'a'}
            external={external}
            className={classes.link}
            onClick={() => {
              onClick && onClick()
              id === 'suggest-book-title' && handleToggleSuggestTitle()
              eventName && logEvent(eventName, eventProps)
            }}
          >
            {Icon && <Icon fontSize="small" className={classes.icon} />}
            {name}
          </Link>
        ),
      )}
      <Dialog ref={dialogRef} toggleDialog={toggleDialog(dialogRef)} />
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  grid: ({ oldVersion }) => ({
    flexGrow: 1,
    ...(!oldVersion && {
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(3),
      },
    }),
  }),
  title: ({ oldVersion }) => ({
    fontWeight: 500,
    ...(oldVersion
      ? {
          color: colors.grayedwhite,
        }
      : {
          color: colors.black,
          textAlign: 'center',
        }),
  }),
  link: ({ oldVersion }) =>
    oldVersion
      ? {
          color: '#FFF',
          fontWeight: 500,
          display: 'flex',
        }
      : {
          color: colors.black,
          fontWeight: 400,
          textAlign: 'center',
          display: 'block',
        },
  icon: {
    marginRight: theme.spacing(1),
  },
}))
